import { useEffect } from 'react'
import { Outlet, useNavigate, useParams } from 'react-router-dom'

import { F0Alert, F0Box } from '@factorialco/f0-react'
import { Spinner } from '@factorialco/f0-react/dist/experimental'
import { TrainingContentRootDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import CollectionsBootstrap from 'modules/trainings/lib/ContentCollectionsBootstrap'

const ContentRoot = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { id } = useParams()

  const {
    company: { id: companyId },
  } = useCurrentSession()

  const { data: trainingData, loading } = useQuery(TrainingContentRootDocument, {
    fetchPolicy: 'cache-first',
    variables: {
      trainingId: Number(id),
      companyId,
    },
  })

  const hasLMSModule =
    trainingData?.companies.moduleAvailabilitiesConnection.nodes.some(
      (x) => x.id === 'lms' && x.available
    ) ?? false

  const hasContentFF = hasLMSModule
  const isScormTraining = Boolean(trainingData?.trainings.training?.scormPackage)

  const overviewPath = navigation.trainings.list.details_revamp.view.overview.fullPath({
    id: Number(id),
  })

  useEffect(() => {
    if (!loading && !hasContentFF && !isScormTraining) {
      navigate(overviewPath)
    }
  }, [loading, hasContentFF, isScormTraining, navigate, overviewPath])

  if (loading) {
    return (
      <F0Box padding="xl" width="full" alignItems="center">
        <Spinner />
      </F0Box>
    )
  }

  if (isScormTraining) {
    return (
      <F0Box padding="xl" width="full">
        <F0Alert
          variant="warning"
          title={i18n.t('trainings.scorm.content_builder_unavailable.title')}
          description={i18n.t('trainings.scorm.content_builder_unavailable.description')}
          action={{
            label: i18n.t('trainings.scorm.content_builder_unavailable.go_back'),
            onClick: () => navigate(overviewPath),
          }}
        />
      </F0Box>
    )
  }

  if (!hasContentFF) {
    return null
  }

  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default ContentRoot
